import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de Anthropic -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas sobre el texto real de pdfjs. Obligatorios (throw): folio, monto.
// CRITICO: el guion del folio (y a veces del concepto) sale como U+0000 (byte nulo) en el texto de
// pdfjs real -> se normaliza a "-". Se referencia el nulo via escape ASCII (nunca byte literal).
// eslint-disable-next-line no-control-regex -- U+0000 es el guion real del folio en el texto de pdfjs.
const NULO = new RegExp("\\u0000", "g");

export const parsearAnthropicDesdeTexto = (texto) => {
  // folio: entre "Invoice number" y "Date of issue" -> U+0000 -> "-", quitar espacios -> "3YK4QC1M-0007".
  // Obligatorio.
  const mFolio = texto.match(/Invoice number([\S\s]*?)Date of issue/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura Anthropic (falta Invoice number)");
  const folio = mFolio[1].replace(NULO, "-").replace(/\s+/g, "").trim();
  if (!folio) throw new Error("No se pudo leer el numero de factura Anthropic");

  // monto: "Amount due  $148.75 USD" -> 148.75 (limpio). Obligatorio.
  const mMonto = texto.match(/Amount due\s*\$\s*([\d,]+\.\d{2})\s*USD/);
  if (!mMonto) throw new Error("No se pudo leer el Amount due de la factura Anthropic");
  const monto = Number(mMonto[1].replace(/,/g, ""));

  // fecha: tras "Date of issue" -> "June 18, 2026" (Month DD, YYYY). Best-effort.
  const mFecha = texto.match(/Date of issue\s*([A-Za-z]+\s+\d{1,2},\s*\d{4})/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;

  // concepto: "Team plan - Standard" (el guion puede venir como U+0000). Best-effort.
  const mConcepto = texto.match(/Team plan[\S\s]{0,4}?Standard/);
  const concepto = mConcepto ? mConcepto[0].replace(NULO, "-").replace(/\s+/g, " ").trim() : "";

  // unidades: Qty de la linea -> 5 (de "...  5   $25.00"). Best-effort.
  const mUnidades = texto.match(/Standard[\S\s]{0,40}?(\d+)\s+\$\d/);
  const unidades = mUnidades ? Number(mUnidades[1]) : null;

  // periodo: derivado de `fecha` (regla sistemica) -> 2026-06-01 desde fecha 2026-06-18.
  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades };
};
